import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuHome } from 'react-icons/lu';
import AppButton from '@/components/atoms/AppButton';
import { Text, Body } from '@/components';
import { ERROR_PAGES } from '@/constant/global/global.constant';
import { APP_BG } from '@/constant/theme/colors.constant';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center ${APP_BG.canvas} px-4`}
    >
      {/* Glowing background blob */}
      <div className="absolute w-[500px] h-[500px] rounded-full bg-primary/10 dark:bg-primary/5 blur-3xl pointer-events-none" />

      <div className="relative z-10 flex flex-col items-center text-center max-w-lg gap-6">
        {/* 404 number */}
        <div className="relative select-none">
          <span
            className="text-[10rem] leading-none font-black tracking-tighter bg-clip-text text-transparent"
            style={{
              backgroundImage:
                'linear-gradient(135deg, var(--color-primary), var(--color-secondary), var(--color-tertiary))',
            }}
          >
            404
          </span>
          {/* Subtle shadow reflection */}
          <span
            className="absolute left-0 right-0 -bottom-4 text-[10rem] leading-none font-black tracking-tighter bg-clip-text text-transparent opacity-10 scale-y-[-1] blur-sm pointer-events-none"
            style={{
              backgroundImage:
                'linear-gradient(135deg, var(--color-primary), var(--color-secondary))',
            }}
            aria-hidden
          >
            404
          </span>
        </div>

        {/* Divider pill */}
        <div
          className="h-1 w-20 rounded-full"
          style={{
            background:
              'linear-gradient(90deg, var(--color-primary), var(--color-tertiary))',
          }}
        />

        {/* Text */}
        <div className="flex flex-col gap-2">
          <Text as="h1" size="3xl" weight="bold" color="default">
            {ERROR_PAGES.NOT_FOUND.TITLE}
          </Text>
          <Body color="muted" className="leading-relaxed">
            {ERROR_PAGES.NOT_FOUND.BODY}
          </Body>
        </div>

        {/* CTA */}
        <AppButton
          variant="primary"
          size="lg"
          shape="pill"
          icon={<LuHome className="w-4 h-4" />}
          onClick={() => navigate('/dashboard')}
        >
          {ERROR_PAGES.NOT_FOUND.CTA}
        </AppButton>
      </div>
    </div>
  );
};

export default NotFound;
